import React, { createContext, useContext, useState } from 'react'

interface NavShellState {
  /** Hide the bottom nav entirely (e.g. bulk mode, fullscreen modals) */
  hidden: boolean
  setHidden: (hidden: boolean) => void
  /** Current route name, set by NavigationContainer's onStateChange */
  routeName: string
  setRouteName: (name: string) => void
  /** Current route params */
  routeParams: Record<string, unknown>
  setRouteParams: (params: Record<string, unknown>) => void
}

const NavShellContext = createContext<NavShellState>({
  hidden: false,
  setHidden: () => {},
  routeName: '',
  setRouteName: () => {},
  routeParams: {},
  setRouteParams: () => {},
})

export function NavShellProvider({ children }: { children: React.ReactNode }) {
  const [hidden, setHidden] = useState(false)
  const [routeName, setRouteName] = useState('')
  const [routeParams, setRouteParams] = useState<Record<string, unknown>>({})

  return (
    <NavShellContext.Provider value={{ hidden, setHidden, routeName, setRouteName, routeParams, setRouteParams }}>
      {children}
    </NavShellContext.Provider>
  )
}

/** Control the navigation shell from any screen */
export function useNavShell() {
  return useContext(NavShellContext)
}
